import React from "react";
import MetaAdminPanel from "../Contents/Administration/Dashboard/Meta/MetaAdminPanel";
import FieldTypesEnum from "../Enums/FieldTypesEnum";
import dateTimeHelper from "../Helpers/datetimeHelper";
import TabListTableCellWidthEnum from "../Enums/TabListTableCellWidthEnum";
import LogComponent from "../Elements/LogComponent";
import DataTableActionMenu from "../Elements/DataTable/DataTableActionMenu";

export default class ReportTemplateItem
{
  constructor (item)
  {
    if (item === undefined)
    {
      this.ReportTemplateId = "";
      this.Name = "";
      this.TemplateName = "";
      this.OfficeParameterTypeCode = "";
      this.ClientParameterTypeCode = "";
      this.ProjectParameterTypeCode = "";
      this.CreatedOn = "";
      this.ModifiedOn = "";
      return;
    }
    this.ReportTemplateId = item.reportTemplateId;
    this.Name = item.name;
    this.TemplateName = item.templateName;
    this.OfficeParameterTypeCode = item.officeParameterTypeCode;
    this.ClientParameterTypeCode = item.clientParameterTypeCode;
    this.ProjectParameterTypeCode = item.projectParameterTypeCode;
    this.CreatedOn = item.createdOn;
    this.ModifiedOn = item.modifiedOn;
  }

  static NameOfTheIdField ()
  {
    return "ReportTemplateId";
  }
  static nameOfTheItemDetailList ()
  {
    return "Report Template";
  }

  static MoneyFields = [];

  static Currency ()
  {
    return "USD";
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary ()
  {
    return "USD";
  }

  static DateFields = [ "CreatedOn", "ModifiedOn" ];

  static BoolFields = [];

  static FieldsToShowInListTable = [
    {
      tabName: "General",
      tabLabel: "General",
      icon: "fa-solid fa-home",
      data: [
        { name: "ReportTemplateId", label: "Id" },
        { name: "Name", label: "Name" },
        { name: "TemplateName", label: "Template Name" },
        { name: (item) => ReportTemplateItem.TemplateTypeCode(item.OfficeParameterTypeCode), label: "Office Parameter Type Code" },
        { name: (item) => ReportTemplateItem.TemplateTypeCode(item.ClientParameterTypeCode), label: "Client Parameter Type Code" },
        { name: (item) => ReportTemplateItem.TemplateTypeCode(item.ProjectParameterTypeCode), label: "Project Parameter Type Code" },
        { name: "CreatedOn", label: "Created" },
        { name: "ModifiedOn", label: "Modified" },
      ],
    },
    {
      tabName: "Meta",
      tabLabel: "Meta",
      icon: "fa-solid fa-betamax",
      data: [
        {
          name: ReportTemplateItem.GetMetaData,
          label: "",
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: "Log",
      tabLabel: "Log",
      icon: "fa-solid fa-stream",
      data: [
        {
          name: ReportTemplateItem.getLogContent,
          label: "Log",
          width: TabListTableCellWidthEnum.TwoLines,
        },
      ],
    },
  ];

  static getLogContent (item)
  {
    return <LogComponent entityType="ReportTemplate" entityId={item.ReportTemplateId} />;
  }

  static GetMetaData (item)
  {
    return <MetaAdminPanel ReportTemplateId={item.ReportTemplateId} />;
  }

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show
  //   if type is FieldTypesEnum.FunctionField then it is the function
  //   In the following example the FreelancerUserItem.editFunction function is a static variable in this class, so you can change its value
  //   I change the value in the constructor of the FreelancerUserAdmin component
  static FieldsToShowInDataTable ()
  {
    return [
      { label: "Id", orderById: "", data: "ReportTemplateId", type: FieldTypesEnum.DataFieldWithDetails },
      { label: "Name", orderById: "", data: "Name" },
      { label: "Template Name", orderById: "", data: ReportTemplateItem.getTemplateNameCellContent },
      { label: "Office Parameter Type", orderById: "", data: (item) => this.TemplateTypeCode(item.OfficeParameterTypeCode) },
      { label: "Client Parameter Type", orderById: "", data: (item) => this.TemplateTypeCode(item.ClientParameterTypeCode) },
      { label: "Project Parameter Type", orderById: "", data: (item) => this.TemplateTypeCode(item.ProjectParameterTypeCode) },
      { label: "Created On", orderById: "", data: (item) => dateTimeHelper.toYYYYsMMsDDWithIndefiniteIcon(item.CreatedOn) },
      { label: "Modified On", orderById: "", data: (item) => dateTimeHelper.toYYYYsMMsDDWithIndefiniteIcon(item.ModifiedOn) },
      { label: " ", orderById: "", data: ReportTemplateItem.getActionButtonContent, type: FieldTypesEnum.ActionButton },
    ];
  }

  static getActionButtonContent (item)
  {
    let add = null;
    const edit = {
      iconName: "fa-solid fa-edit",
      onClick: () => ReportTemplateItem.editTemplateFileFunction(item.ReportTemplateId, item),
      text: "Edit",
      roleKey: "reporttemplateEdit",
    };
    let remove = null;
    if (item.TemplateName)
    {
      remove = {
        iconName: "fa-regular fa-trash-can",
        onClick: () => ReportTemplateItem.removeTemplateFunction(item.ReportTemplateId, item),
        text: "Remove template",
        roleKey: "reporttemplateRemove",
      };
    } else
    {
      add = {
        iconName: "fa-solid fa-plus-circle",
        onClick: () => ReportTemplateItem.addNewTemplateFunction(item.ReportTemplateId, item),
        text: "New template",
        roleKey: "reporttemplateNew",
      };
    }
    const options = [ add, edit, remove ];

    return <DataTableActionMenu options={options} />;
  }

  static getTemplateNameCellContent (item)
  {
    return (
      <span className="link" onClick={() => ReportTemplateItem.clickOnTemplateName(item.ReportTemplateId, item)}>
        {item.TemplateName}
      </span>
    );
  }

  static clickOnTemplateName () { }

  static TemplateTypeCode (code)
  {
    let res = "";
    switch (code)
    {
      case 1:
        res = "Required";
        break;
      case 2:
        res = "Optional";
        break;
      default:
        res = "Disabled";
        break;
    }
    return res;
  }

  static editFunction = (id, item, itemList) =>
  {
    alert("Empty function");
  };

  static editTemplateFileFunction = (id, item, itemList) =>
  {
    alert("Empty function");
  };

  static addNewTemplateFunction = (id, item, itemList) =>
  {
    alert("Empty function");
  };

  static removeTemplateFunction = (id, item, itemList) =>
  {
    alert("Empty function");
  };
}
